import { render, staticRenderFns } from "./CurrentPlans.vue?vue&type=template&id=3804ca4f&scoped=true"
import script from "./CurrentPlans.vue?vue&type=script&lang=js"
export * from "./CurrentPlans.vue?vue&type=script&lang=js"
import style0 from "./CurrentPlans.vue?vue&type=style&index=0&id=3804ca4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804ca4f",
  null
  
)

export default component.exports